import type { CellContext, ColumnDef } from "@tanstack/react-table";
import capitalize from "lodash/capitalize";

import { changeVulnStateFormatter } from "../change-vulns-state-formatter";
import type { IVulnData } from "../types";

export const getColumns = (
  handleUpdateRepo: (vulnInfo: Record<string, string>) => void,
): ColumnDef<IVulnData>[] => [
  {
    accessorKey: "where",
    header: "Where",
  },
  {
    accessorKey: "specific",
    header: "Specific",
  },
  {
    accessorKey: "state",
    cell: (cell: CellContext<IVulnData, unknown>): string =>
      capitalize(cell.row.original.state),
    header: "State",
  },
  {
    accessorKey: "toggleState",
    cell: (cell: CellContext<IVulnData, unknown>): JSX.Element =>
      changeVulnStateFormatter(
        cell.row.original as unknown as Record<string, string>,
        handleUpdateRepo,
      ),
    header: "Toggle State",
    sortingFn: (rowA, rowB): number => {
      const stateA = rowA.original.state !== "SAFE";
      const stateB = rowB.original.state !== "SAFE";

      if (stateA === stateB) {
        return 0;
      } else if (stateA) {
        return 1;
      }

      return -1;
    },
  },
];
